<template>
    <layout>
        <TitleLable parentMessage="设置考试时间表" :showback="true"></TitleLable>
        <div class="plan_button" style="margin-bottom: 20px;">
            <el-input style="width: 400px;" v-model="title" placeholder="请输入本次考试标题"></el-input>
        </div>
        <div class="plan_button" style="margin-bottom: 20px;">
            <el-radio-group v-model="makeup">
                <el-radio size="medium" label="0">正式考试</el-radio>
                <el-radio size="medium" label="1">补考</el-radio>
            </el-radio-group>
        </div>
        
        
        <div class="plan_button" style="margin-bottom: 20px;">
            
            <span class="trem" v-for="(item,index) in trem_data" :key="index" @click="clickTrem(index)" :style="trem_index==index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
        </div>
        <div class="plan_button" style="margin-bottom: 20px;">
            <TitleLable style="font-size: 14px;" parentMessage="选择年级" :showback="false"></TitleLable>

            <span class="trem" v-for="(item,index) in gradeResult" :key="index" @click="clickGrade(index)" :style="loading_index==index?'background-color:#409eff;color:#ffffff':''">{{ item }}</span>
            
        </div>
        <div class="tabs">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="选择老师、班级" name="first">
                    <div v-if="is_admin" class="teach_button" style="margin-bottom: 20px;">
                        <TitleLable style="font-size: 14px;" parentMessage="选择老师" :showback="false"></TitleLable>
                        
                        <span class="trem" v-for="(item,index) in teachResult" :key="index" @click="clickTeach(item.id,item.name)" :style="plan_index==item.id?'background-color:#409eff;color:#ffffff':''">{{ item.name }}</span>
                        <span style="width: 100%;text-align: center;opacity: 0.7;display: inline-block;" v-if="!teachResult.length">暂无老师</span>
                    </div>
                    <div class="plan_list" style="margin-bottom: 20px;">
                        <TitleLable style="font-size: 14px;" parentMessage="选择班级" :showback="false"></TitleLable>
                  
                        <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
                        <el-checkbox-group v-model="checkList">
                            
                            <el-checkbox v-for="(item,index) in planResult" :key="index" :label="item.id" :value="item.id" >{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="导入名单" name="second">
                    <div class="custom-file-upload">  
                        <input type="file" @change="importExcel" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                        <label class="el-icon-upload2" for="myFile"> 导入名单</label>  
                    </div>
                    <div style="display: inline-block;line-height: 23px;font-size: 14px;margin-left: 10px;"><i class="el-icon-warning" style="color: #F56C6C;"></i> 请严格按照模板格式适导入，<span @click="downExcelTemp" style="color: #409EFF;cursor: pointer;">点我下载模板</span></div>
                    <div class="schedule-list">
                        <!-- 表头 -->
                        <div class="list-header">
                            <div class="time-range">时间段</div>
                            <div class="name">导入班级</div>
                            <div class="name">对比结果</div>
                            <div class="teacher">结果</div>
                        </div>

                        <!-- 数据列表 -->
                        <transition-group 
                            name="staggered-list"
                            tag="div"
                            class="list-body"
                        >
                            <div v-for="(item, index) in jsonOutput"
                                :key="item.plan_id"
                                class="list-item"
                                :style="{ '--order': index }"
                            >
                                <div class="time-range">
                                    {{ item.time_text }}
                                </div>
                                <div class="name">
                                    {{ item.name }}
                                </div>
                                <div class="name">
                                    {{ item.diffname }}
                                    <span class="plan-id">(ID: {{ item.plan_id || '' }})</span>
                                </div>

                                <div class="teacher">
                                    <span v-if="item.flag" style="font-size: 26px;color: #409EFF;" class="el-icon-success"></span>

                                    <span v-if="!item.flag" style="font-size: 26px;color: #F56C6C;" class="el-icon-error"></span>
                                </div>

                            </div>
                        </transition-group>
                        
                    </div>
                    <div v-if="activeName == 'second'" style="text-align: center;">
                        <el-button type="danger" size="small" @click="addSettingExcel">添加到时间表</el-button>
                        <el-button type="info" size="small" @click="removeSettingExcel">重置</el-button>
                    </div>
                    
                </el-tab-pane>
            </el-tabs>
        </div>
        
        
        <div v-if="planResult.length && activeName == 'first'" class="teach_button" style="margin-bottom: 20px;">
            <TitleLable parentMessage="选择考试时间" :showback="false"></TitleLable>
            <el-date-picker
                
                    v-model="date"
                    type="datetimerange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right">
                </el-date-picker>
            
        </div>
        
        <div class="add_button">
            <el-button v-if="activeName == 'first'" type="danger" size="small" @click="addSetting">添加到时间表</el-button>
        </div>
        <el-table v-if="tableData.length" :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
            <el-table-column
            prop="time"
            label="场次"
            width="180">
            </el-table-column>
            <el-table-column
            prop="name"
            label="班级名称">
            </el-table-column>
            <el-table-column
            prop="teach_name"
            width="200"
            label="老师">
            </el-table-column>
            <el-table-column
            prop="time_text"
            label="考试时间">
            </el-table-column>
            
            <el-table-column width="200" label="操作">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="tableData.length" class="add_button">
            <el-button type="danger" :loading="submitload" class="el-icon-setting" size="small" @click="submitPlan"> {{ submit_text }}</el-button>
            
        </div>
        <el-link type="danger" :underline="false">注：请先设置完时间表再进行提交</el-link>
    </layout>
</template>
<script>
import TitleLable from '../../units/Titlelabel.vue';
import Http from "../../apis/exam";
import * as XLSX from 'xlsx';
import moment from 'moment';
import throttle from 'lodash/throttle'
import axios from 'axios';
export default {
    components:{
        TitleLable
    },
    data(){
        return{

            date:'',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            trem_data:{},
            gradeResult:[],
            teachResult:{},
            planResult:[],
            loading_index:0,
            plan_index:0,
            plan_flag:false,
            flag:false,
            checkList:[],
            trem_index:0,
            tableData: [],
            rowspanMap:{},
            teach_name:'',
            title:'',
            makeup:'0',
            submit_text:'时间表确认设置',
            is_admin:0,
            submitload:false,
            jsonOutput:[],
            activeName: 'first',
            teach_id:'',
            teachPlan:[]
            
        }
    },
    activated(){
        var user_info = JSON.parse(localStorage.getItem('userinfo'))
        this.is_admin = user_info.is_admin
        this.getGrade()
        //this.calculateRowspan();
    },
    
    watch:{
        makeup(value){
            this.changeRadio()
        }
    },
    methods:{
        handleClick(tab, event) {
            this.activeName = tab.name;
        },
        downExcelTemp(){
            window.open(`${axios.defaults.baseURL}/template/tt1.xlsx`, '_blank');
        },
        // 重置导入数据
        removeSettingExcel(){
            this.tableData = []
            this.jsonOutput = []
        },
        // 导入表格
        async importExcel(event){
            const file = event.target.files[0];
            if (!file) return;
            const fileName = file.name;
            const fileExtension = fileName.split('.').pop().toLowerCase(); // 获取文件后缀并转为小写
            if (fileExtension !== 'xlsx') {
                this.$message({
                    message:'请上传 .xlsx 格式的文件',
                    type:'error'
                })
                event.target.value = null; // 清空文件输入框
                return;
            }
            const reader = new FileReader();
            reader.onload = async (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                
                const transformedData = this.transformData(jsonData);
                    
                // 3. 先发送对比请求
                const diffResult = await Http.diffExcel(transformedData); 
                const result = diffResult.data

                console.log(result)
                // 清空当前数据
                this.jsonOutput = [];
                
                // 使用节流函数逐条添加
                const addItem = throttle((item, index) => {
                    this.jsonOutput.push(item);
                }, 100); // 间隔时间100ms

                //const transformedData = this.transformData(jsonData);
                result.forEach((item, index) => {
                    setTimeout(() => addItem(item, index), index * 150);
                });
                event.target.value = null;  
            };
            
            reader.readAsArrayBuffer(file);

        },
        transformData(rows) {
            let currentTimeRange = null;
            const result = [];

            rows.forEach((row) => {
                // 检查是否是时间行（A列有值）
                if (row[0]) {
                    // 解析时间范围，例如："2025/03/07 09:00-09:40"
                    const timeRange = row[0].trim();
                    const [startPart, endPart] = timeRange.split('-');
                    
                    // 处理起始时间
                    const startTime = moment(startPart, "YYYY/MM/DD HH:mm").format("YYYY-MM-DD HH:mm:ss");
                    
                    // 处理结束时间（补全日期）
                    const endDate = startPart.split(' ')[0]; // 取起始时间的日期部分
                    const endTime = moment(`${endDate} ${endPart}`, "YYYY/MM/DD HH:mm").format("YYYY-MM-DD HH:mm:ss");

                    currentTimeRange = { startTime, endTime };
                }

                // 处理课程行（B列有值）
                if (row[1] && currentTimeRange) {
                    result.push({
                        time: currentTimeRange.startTime,
                        end_time: currentTimeRange.endTime,
                        name: row[1].trim(),
                        time_text: `${currentTimeRange.startTime} 到 ${currentTimeRange.endTime}`,
                        //teach_name: "",
                        //plan_id: ++planIdCounter,
                    });
                }
            });

            
            return result;
        },

        addSettingExcel(){
            this.tableData = this.jsonOutput
            this.checkList = []
            this.calculateRowspan()
            
        },
        changeRadio(){
            if(this.makeup == '1'){
                this.submit_text = '发布补考'
            }else{
                this.submit_text = '时间表确认设置'
            }
            console.log(this.makeup)
        },
        // 设置完成提示
        submitPlan(){
            this.submitload = true
            this.$confirm('提交前请再次确认时间表是否有误？请确认无误后再提交', '提示', {
                confirmButtonText: '确认提交',
                cancelButtonText: '再次确认',
                type: 'warning'
            }).then(() => {
                this.cratePlanMessage()
            }).catch(() => {
                this.submitload = false        
            });
      
        },

        cratePlanMessage(){

            const loading = this.$loading({
                lock: true,
                text: '通知发送中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.1)'
            });
            var data = JSON.parse(JSON.stringify(this.tableData))
            var row = []
            for(var i in data){
                var result = {}
                result.start_time   = data[i].time
                result.end_time     = data[i].end_time
                result.plan_id      = data[i].plan_id
                result.grade        = this.loading_index
                row.push(result)
            }
            var params = {}
            params.tableData = row
            params.trem   = this.trem_index
            params.makeup = this.makeup
            params.title  = this.title
            params.grade  = this.loading_index
            
            Http.createMessage(params).then((res) => {
                localStorage.setItem('nids', res.data);
                loading.close()
          
                
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: res.code?'success':'error'
                });
                if(res.code){
                    if(this.makeup == 1){
                        this.$router.push({ name: 'Examlist'});
                    }else{
               
                        this.submitload = false
                        this.$router.push({ name: 'Createpaper',query:{trem:this.trem_index,grade:this.loading_index}}); 
                    }
                    this.clearForm();
                }
            });
        },

        getGrade(){
            Http.getPlanGrade().then((res) => {
                if(!res.code){
                    this.$message({
                        message:res.msg,
                        type:'error'
                    })
                    return
                }
                this.gradeResult = res.data.result
                this.trem_data = res.data.trem_data
            });
        },
        // 设置时间表
        addSetting(){

            if(!this.date){
                this.$message({
                    showClose: true,
                    message: '请先设置考试时间',
                    type: 'error'
                });
                return false;
            }
            if(!this.title){
                this.$message({
                    showClose: true,
                    message: '请输入本次考试标题',
                    type: 'error'
                });
                return false;
            }
            const start_time = this.$Common.newDateFormat_(this.date[0])
            const end_time = this.$Common.newDateFormat_(this.date[1])
            if(start_time == end_time){
                this.$message({
                    showClose: true,
                    message: '考试开始时间和结束时间不能一致',
                    type: 'error'
                });
                return false;
            }
            
            const time = `${start_time} 到 ${end_time}`;
            // var result = this.planResult.filter((item)=>{
            //     return this.checkList.includes(item.id);
            // });

            var result = this.teachPlan.filter(item => this.checkList.includes(item.id));


   
            const data = []
            for(var index in result) {
                const row = {};
                row.time = start_time
                row.end_time = end_time
                row.name = result[index].name
                row.time_text = time
                row.teach_name = result[index].teach_name
                row.plan_id = result[index].id
                data.push(row)
            }

            // 检查是否有重复数据
            for (let newRow of data) {
                for (let existingRow of this.tableData) {
                    if (newRow.time === existingRow.time && newRow.name === existingRow.name) {
                        this.$message({
                            showClose: true,
                            message: `班级 ${newRow.name} 在 ${newRow.time_text} 已有考试安排，请勿重复设置。`,
                            type: 'error'
                        });
                        return false;
                    }
                }
            }
            
            if(this.tableData.length){
                
                this.tableData = [...this.tableData,...data]

            }else{
                this.tableData = data
            }
            
            this.calculateRowspan()
        },
        clickGrade(index){
            this.loading_index = index
            if(!this.is_admin){
                this.getnotAdminPlan()
                return false;
            }
            var params = {}
            params.grade = index
            Http.getTeach(params).then((res) => {
  
                this.teachResult = res.data

                if(this.teach_id){
                    this.clickTeach(this.teach_id,this.teach_name)
                }
            });
        },
        getnotAdminPlan(){
            var params = {}
            params.grade = this.loading_index
            Http.getnotAdminPlan(params).then((res) => {
  
                this.planResult = res.data
            });
        },
        clickTeach(id,name){
            this.teach_id = id
            var params = {}
            this.plan_index = id
            this.teach_name = name
            params.teach_id = this.teach_id
            params.grade = this.loading_index
            Http.getTeachPlan(params).then((res) => {
                var data = res.data

                var newItems = data.filter(bItem => 
                    !this.planResult.some(aItem => aItem.id === bItem.id)
                );

                // 合并到a中
                this.teachPlan = [...this.planResult, ...newItems]; 

                this.planResult = data
            });
        },
        handleDelete(index,row){

            this.tableData.splice(index, 1);
        },
        clickTrem(index){
            this.trem_index = index
        },
        calculateRowspan() {
            const idGroup = {};
            this.tableData.forEach((row, index) => {
                if (!idGroup[row.time]) {
                    idGroup[row.time] = [];
                }
                idGroup[row.time].push(index);
            });
            const rowspanMap = {};
            Object.keys(idGroup).forEach((time) => {
                const indexes = idGroup[time];
                indexes.forEach((index, i) => {
                    if (i === 0) {
                        rowspanMap[index] = indexes.length;
                    } else {
                        rowspanMap[index] = 0;
                    }
                });
            });
            this.rowspanMap = rowspanMap;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                return {
                    rowspan: this.rowspanMap[rowIndex],
                    colspan: 1
                };
            }
            return {
                rowspan: 1,
                colspan: 1
            };
        },

        clearForm(){

            this.title = ''
            this.makeup = '0'
            this.trem_index = 0
            this.loading_index = 0
            this.plan_index = 0
            this.planResult = []
            this.date = ''
            this.checkList = []
            this.tableData = []
            this.teachResult = []
        }
  
    }
}
</script>
<style lang="less" scoped>
.plan_button{
    display: inline-block;
    width: 100%;
    margin-top: 20px;
}
.trem{
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
.add_button{
    display: inline-block;
    width: 100%;
    text-align: center;
    margin-top: 15px;
}
.plan_list{
    width: 100%;
    display: inline-block;
    margin-top: 20px;

    .el-checkbox{
        width: 200px;
        margin-bottom: 10px;
    }
}
.teach_button{
    display: inline-block;
    width: 100%;
    margin-top: 20px;

    .el-button{
        margin-bottom: 10px;
        margin-left: 0;
        margin-right: 10px;
    }
}

.custom-file-upload {  
    position: relative;
    border-radius: 4px;  
    display: inline-block;  
    cursor: pointer;  
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 3px;
}  
  
.custom-file-upload input[type="file"] {  
    position: absolute;
    top: 0;  
    right: 0;  
    opacity: 0;  
    outline: none;  
    cursor: inherit;  
    width: 76px;
}  
  
.custom-file-upload label {  
    font-size: 12px;
    border-radius: 4px;  
    padding: 9px 15px;
    border: none;
    text-align: center;  
    background-color: #409EFF;
    color: #ffffff;
    border-color: #409EFF;
}

.schedule-list {
  margin: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  font-size: 14px;

  .list-header {
    display: flex;
    padding: 16px;
    background: #f8f9fa;
    font-weight: 600;
    border-bottom: 2px solid #eee;
    color: #666;
    
    > div {
      text-align: center; // 表头文字居中
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .list-body {
    padding: 0 16px;
  }

  .list-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    transition: background 0.2s;
    
    > div {
      padding: 0 8px;
      text-align: center;
      align-items: center;
      justify-content: center;
    }
  }

  .time-range {
    flex: 0 0 310px; // 保持固定宽度
    color: #2c3e50;
    font-weight: 500;
    justify-content: flex-start; // 时间列保持左对齐
    padding-left: 20px; // 增加左边距
  }

  .name {
    flex: 1;
    min-width: 220px;
    flex-direction: column; // 垂直排列
  }

  .teacher {
    flex: 0 0 150px;
  }


}

button {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: all 0.2s;
}

.edit-btn {
  background: #e8f4ff;
  color: #1890ff;
}

.edit-btn:hover {
  background: #d0e8ff;
}

.delete-btn {
  background: #ffece8;
  color: #ff4d4f;
}

.delete-btn:hover {
  background: #ffdcd6;
}

/* 添加动画样式 */
.staggered-list-enter-active {
    animation: slideIn 0.6s ease both;
    animation-delay: calc(var(--order) * 0.15s);
}

.staggered-list-leave-active {
    animation: slideOut 0.3s ease;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideOut {
    from {
        opacity: 1;
        transform: translateY(0);
    }
    to {
        opacity: 0;
        transform: translateY(-20px);
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .staggered-list-enter-active {
        animation-delay: calc(var(--order) * 0.1s);
    }
}
</style>